import styled from 'styled-components'

export const IconStyle = styled.img`
  margin: 15px 0;
  width: 200px;

  @media screen and (max-width: 720px) {
    margin: 10px 0;
    width: 150px;
  }

  @media screen and (max-width: 480px) {
    margin: 5px 0;
    width: 100px;
  }
`
